// React
import { forwardRef } from "react";

// MUI
import { Box, Typography } from "@mui/material";

// i18n
import { useTranslation } from "react-i18next";

// Style
import { styles } from "./styles";

const getChipPropsByStatus = (inSystem) =>
  inSystem
    ? { labelKey: "mbsSearch.table.sourceInSystem", color: "primary" }
    : { labelKey: "mbsSearch.table.sourceGuest", color: "secondary" };

/**
 * @brief Acts as a chip that can have a primary or secondary colour
 * @param variant One of "primary" or "secondary". Default to primary if not supplied or differs
 * @param sx additional MUI sx prop
 * @param inSystem If provided and children are omitted, renders the default in-system/guest label
 * @param children Child components to render
 */
export const MBSChip = forwardRef(
  ({ variant, sx, inSystem, children }, ref) => {
    const { t } = useTranslation();
    const chipProps = getChipPropsByStatus(inSystem);
    const resolvedVariant = variant || chipProps?.color;

    return (
      <Box
        ref={ref}
        sx={{ ...styles.chipBox(resolvedVariant !== "secondary"), ...sx }}
      >
        {children || (
          <Typography variant="subtitle2" color="white" px={1} py={0.25}>
            {t(chipProps.labelKey)}
          </Typography>
        )}
      </Box>
    );
  }
);
